import { observable, action, decorate } from 'mobx';

class ViewStore {
  constructor({ pubSub }) {
    this.modal = {
      opened: undefined,
      isLoading: undefined,
      params: {},
    };
    this.maxPagesWidth = 1254;

    this.subscribeToActions(pubSub);
  }

  subscribeToActions({ subscribe, TOPICS }) {
    subscribe(TOPICS.SHOW_MODAL_DIALOG, (msg, data) => this.openModal(data));
  }

  get openedModal() {
    return this.modal.opened;
  }

  get isModalLoading() {
    return this.modal.isLoading;
  }

  openModal = (modal) => (this.modal.opened = modal);

  closeModal = () => {
    this.modal.opened = null;
    this.setLoading(false);
  };

  getParams = () => this.modal.params;

  setParams = (params) => (this.modal.params = observable({ ...params }));

  setLoading = (isLoading) => (this.modal.isLoading = isLoading);

  get maxWidth() {
    return this.maxPagesWidth;
  }
}

export default decorate(ViewStore, {
  modal: observable,
  openModal: action,
  closeModal: action,
  setLoading: action,
});
